<template>
  <div class="home">
    <shell @pageend="pageLocalItems">
      <template v-slot:default>
        <div class="lg:w-full container m-auto">
          <div class="w-full lg:w-1/2 m-auto relative">
            <div>
              <div class="px-2">
                <t-text kind="DANGER" v-if="error">{{error}}</t-text>
                <div v-if="count">
                  <t-text lvl="1" class="pb-4">Imported <span>{{count}} notes</span> from <strong>{{displayType}}</strong> <span> on {{displayDate}}</span></t-text>
                </div>
                <div class="flex justify-end">
                  <t-button danger :disabled="!count" @click="deleteImport">Delete Import</t-button>
                </div>
                <div v-if="failures.length">
                  <t-text kind="DANGER">Failed to import {{failures.length}} note{{failures.length > 1 ? 's' : ''}}</t-text>
                  <div v-for="f in failures" class="my-4">
                    <t-text-area :value="f.text"></t-text-area>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-2">
              <div class="m-auto">
                <div class="w-full">
                  <record-list :records="renderedRecs" :showUrls="false" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </shell>
  </div>
</template>
<script>
 import {DateTime} from 'luxon';
 import Worker from 'simple-web-worker'
 import {mapState, mapActions} from 'vuex'
 import eventBus from '@/eventBus'
 import api from '@/api'
 import RecordList from '@/components/RecordList'
 import Shell from '@/components/Shell'
 

 export default {
   name: 'import',
   props: {
     shortId: {
       type: String,
       default: ''
     }
   },
   data () {
     return {
       response: '',
       records: [],
       error: '',
       name: '',
       count: '',
       type: '',
       date: '',
       pageNum: 0,
       running: false,
       failures: []
     }
   },

   components: { RecordList, Shell },

   computed: {
     ...mapState({
       member: state => state.member
     }),
     displayDate () {
       return DateTime.fromISO(this.date).toFormat('LLL dd, yyyy')
     },
     displayType () {
       return ({KEEP: 'Google Keep', PINBOARD: 'pinboard.in'})[this.type]
     },
     renderedRecs () {
       return this.records.slice(0, this.pageNum * 20)
     }
   },

   async created () {
     const {res: imp, err: impErr} = await api.getImport(this.shortId)
     const {res: records, err: recErr} = await api.getImportRecords(this.shortId)
     this.response = records

     this.pageLocalItems()

     if (impErr) {
       this.error = impErr.response.data
       this.$router.replace({name: 'imports'})
       return
     } else if (recErr) {
       this.error = recErr.response.data
       return
     }

     this.failures = imp.failures

     this.name = imp.name
     this.count = imp.num_records
     this.type = imp.type
     this.date = imp.created_at
   },

   methods: {
     async deleteImport () {
       if (confirm(`Are you sure you want to delete all ${this.records.length} record${this.records.lengths > 1 ? 's' : ''}`)) {
         const {err} = await api.deleteImport(this.shortId)

         if (err) {
           this.error = err.response.data
         } else {
           this.$router.replace({name: 'imports'})
         }
       }
     },

     async pageLocalItems (done = () => {}) {
       if (!this.response || this.running) {
         return done()
       }

       this.running = true

       const {recs, nextIndex} = await Worker.run(
         (records, index = 0) => {
           const PAGE_SIZE = 50

           return {
             recs: JSON.parse(records).slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE),
             nextIndex: (index + 1) * PAGE_SIZE
           }
         }, [this.response, this.pageNum])

       this.records.push(...recs)

       this.pageNum += 1

       done()

       this.running = false
     }
   }
 }
</script>

